import { render, staticRenderFns } from "./DeptTree.vue?vue&type=template&id=6fc48710&scoped=true"
import script from "./DeptTree.vue?vue&type=script&lang=js"
export * from "./DeptTree.vue?vue&type=script&lang=js"
import style0 from "./DeptTree.vue?vue&type=style&index=0&id=6fc48710&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc48710",
  null
  
)

export default component.exports